<template>
  <zm-row :span="24" class="comparison-tree-table-mobile__plan-row">
    <zm-row class="comparison-tree-table-mobile__feature-row">
      <zm-col :span="24">
        <div class="comparison-tree-table-mobile__feature-title-wrapper">
          <span
            tabindex="-1"
            class="comparison-tree-table-mobile__feature-content"
            :class="[
              'comparison-tree-table-mobile__sub-text',
            ]"
          >
            <span v-if="row.icon" class="table-feature-icon-mobile" :class="'icon-' + panel.icon"></span>
            <span v-html="row.feature"></span>
            <zm-tooltip placement="top">
              <div slot="content" v-html="row.tooltip"></div>
              <button
                data-testid="common-button-75"
                class="comparison-tree-table-mobile__button-icon"
                v-if="row.tooltip"
                :aria-label="row.feature"
                @mousedown="mouseInToolTip(row)"
              >
                <span class="sr-only">{{ t('marketing.helpTooltipIcon') }}</span>
                <i class="zm-icon-info-outline"></i>
              </button>
            </zm-tooltip>
          </span>
          <auto-expire-badge :badgeId="row.badgeId" :theme="'comparison'" style="margin-left: 4px;"/>
          <a
            v-if="row.pdf"
            data-testid="common-a-76"
            tabindex="-1"
            href="https://explore.zoom.us/docs/doc/Phone-NomadicE911-6-2020.pdf"
            target="_blank"
          >
            {{ t('marketing.phone.fullPlanItem20Pdf') }}
          </a>
          <div v-if="row.link">
            <a
              v-if="row.link.callback"
              data-testid="common-a-77"
              :class="row.link.classname || ''"
              :style="row.link.style || {}"
              tabindex="-1"
              href="javascript:void(0);"
              @mousedown="onLinkClick(row)"
              :aria-label="row.link.ariaLabel || row.link.text"
            >
              {{ row.link.text }}
            </a>
          </div>
        </div>
      </zm-col>
    </zm-row>
    <zm-row class="comparison-tree-table-mobile__body-row">
      <zm-col v-for="(col, colIdx) in selectedValues" :key="col" :span="colSpan" :style="colIdx === 0 ? 'padding-right: 4px' : 'padding-left: 4px'">
        <span v-if="isString(row[col])" class="plan-comparison-detail__text" v-html="row[col]"></span>
        <template v-else-if="isBoolean(row[col]) || row[col] === undefined">
          <img v-if="row[col]" src="../../../assets/checked.svg" alt=""/>
          <img v-else src="../../../assets/uncheck.svg" alt=""/>
        </template>
        <template v-else-if="isObject(row[col])">
          <div class="plan-comparison-link-extra">
            <p class="plan-comparison-link-extra__text" v-if="row[col].text">{{ row[col].text }}</p>
            <a data-testid="common-a-78" v-if="row[col].link"
               class="plan-comparison-link-extra__link"
               tabindex="-1"
               :aria-label="row[col].link"
               :class="[{
                      'plan-comparison-link-extra__disabled': row[col].disabled
                    }, ...(row[col].linkClass || [])]"
               @click="row[col].callback()">
              {{ row[col].link }}
            </a>
            <p v-if="row[col].extra">{{ row[col].extra }}</p>
          </div>
        </template>
      </zm-col>
    </zm-row>
  </zm-row>
</template>

<script>
import { t } from '@/plugins/i18n';
import { isBoolean, isObject, isString } from 'lodash';
import AutoExpireBadge from '@/components/AUTO_EXPIRE_BADGE';

export default {
  components: {
    AutoExpireBadge
  },
  props: {
    row: {
      type: Object,
      default: () => ({}),
    },
    selectedValues: Array,
    getColConfigIdx: Function,
    colSpan: Number,
    eventTracking: {
      type: Object,
    },
  },

  methods: {
    t,
    isObject,
    isBoolean,
    isString,
    mouseInToolTip(row) {
      this.eventTracking?.tooltipHoverCallback && this.eventTracking?.tooltipHoverCallback(row?.feature)
    },
    onLinkClick(row) {
      if (row.link?.hasLearnMore) {
        this.eventTracking?.learnMoreCallback && this.eventTracking?.learnMoreCallback(row.feature)
      }
      row.link.callback()
    },
  },
};
</script>

<style lang="scss">
.comparison-tree-table-mobile {
  .cell-desc {
    font-size: 14px;
    line-height: 12px;
    color: #666487;
    text-align: center;
    display: block;
  }
  &__plan-row {
    padding: 0 8px;
    &:nth-child(even) {
      background: #f7f7f8;
    }
  }

  &__feature-row {
    padding: 12px 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.2;
    color: #00053d;
  }

  &__button-icon {
    margin-left: 4px;
    display: inline-block;
    background: transparent;
    border: 0;
  }

  &__body-row {
    display: flex;
    align-items: center;
    padding: 12px 0;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.5;
    text-align: center;
    color: #00053d;
  }

  &__new-content::after {
    position: relative;
    top: -1px;
    margin-left: 4px;
    padding: 2px 4px;
    content: attr(data-label);
    font-size: 12px;
    font-weight: 900;
    color: #0e72ed;
    background-color: #f2f2f4;
    border-radius: 4px;
    text-transform: uppercase;
  }

  .cell-desc {
    display: block;
    font-size: 12px;
    line-height: 1;
    text-align: center;
    color: #666487;
  }

  .zm-icon-info-outline {
    font-size: 14px;
    color: #4f90ee;
    vertical-align: middle !important;
  }
  .zm-icon-ok {
    font-size: 16px;
    font-weight: 700;
    color: #0e72ed;
  }
  .zm-icon-minus {
    font-size: 16px;
    color: rgba(4, 4, 19, 0.56);
    opacity: 0.6;
  }

  .table-feature-icon-mobile {
    display: inline-block;
    margin-top: 3px;
    margin-right: 3px;
    width: 16px;
    height: 16px;
    background-size: contain;
    &.icon-sessions {
      background: url('~@/assets/developer/sessions.svg') no-repeat;
    }
    &.icon-minutes {
      background: url('~@/assets/developer/minutes.svg') no-repeat;
    }
    &.icon-storage {
      background: url('~@/assets/developer/storage.svg') no-repeat;
    }
    &.icon-audio {
      background: url('~@/assets/developer/audio.svg') no-repeat;
    }
    &.icon-connector {
      background: url('~@/assets/developer/connector.svg') no-repeat;
    }
    &.icon-transcription {
      background: url('~@/assets/developer/transcription.svg') no-repeat;
    }
    &.icon-subscription {
      background: url('~@/assets/developer/subscription.svg') no-repeat;
    }
  }
}
</style>
